import {
  Component,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  EventEmitter,
  DOCUMENT
} from '@angular/core';
import { Router, ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MsalService  } from '@azure/msal-angular';
import {
  UtilityService,
  SessionService
} from '@cs/core-data';

import { ToastrService } from 'ngx-toastr';
import JSZip from 'jszip';
import { environment } from '../../environments/environment';

import * as _ from 'lodash';
import  moment from 'moment';
import { MaterialModule } from '@cs/material';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'cs-ads-header',
  standalone: true,
  imports:[CommonModule,MaterialModule,FormsModule,NgxSpinnerModule,AdsHeaderComponent,ReactiveFormsModule,RouterLink,RouterLinkActive],
  templateUrl: './ads-header.component.html',
  styleUrls: ['./ads-header.component.scss']
})
export class AdsHeaderComponent implements OnInit {
  @Input() dataType: string;
  @Input() displayLeftimage: boolean;
  @Input() displayCsv: boolean;
  @Input() isAds: any;
  @Input() showDownload: any;
  @Input() showGoogleSubmit: any;
  @Input() exportInformation: any;
  @Input() selectedTemplate: any;
  @Output() sendInfoToGoogle = new EventEmitter<any>();
  dealer: any = [];

  myForm: FormGroup;
  stored_userDealers:any[] = [];
  selectedpacode: any;
  selectedIndex: any;
  selectedBrand: any;
  public clicked = true;
  public subClicked = false;
  public removeShadow = true;
  public menuTitle;
  public menu: any[];

  public applications = [];
  public currentUserRole = '';
  isLoading = false;
  env: any;
  checkExportClick = false;
  dealerInfo:any[] = [];
  newArrray: any;
  successFlag = false;
  pacode: any;
  role: any;
  isFrame1 = false;
  isFrame2 = false;
  isFrame3 = false;
  globalArr:any[] = [];
  displaymain = false;
  menuIsOpen: boolean = false;
  searchadshow: boolean = true;
  displayadshow: boolean = true;
  uploadshow: boolean = true;
  public csvData:any[] = [];
  public csvData2:any[] = [];
  currentUser: any;

  @Output() filter: EventEmitter<any> = new EventEmitter();
  constructor(
    @Inject(DOCUMENT) document,
    private readonly router: Router,
    private readonly activeRoute: ActivatedRoute,
    private readonly http: HttpClient,
    private readonly fb: FormBuilder,
    private readonly toastrService: ToastrService,
    private readonly utilityService: UtilityService,
    private readonly sessionService: SessionService,
    private readonly msalService: MsalService, 
  ) {
    this.currentUser = this.sessionService.currentUserValue;
  }

  ngOnInit() {
    this.applications = this.currentUser[0].applications;
    console.log("User profile Azure "+this.currentUser);
    this.currentUserRole = this.currentUser[0].role;

    if (this.currentUserRole === 'User') {
      this.checkPermission();
    }

    this.pacode = localStorage.getItem('pacode');
    this.role = localStorage.getItem('role');
    console.log("Active Route"+this.activeRoute);
    this.activeRoute.data.subscribe(data => {
      if (data) {
        this.menuTitle = data['appTitle'];
        this.menu = data['apps'];
        this.isAds = data['isAds'];
      }
    });

    if (!this.isAds && this.menuTitle === 'ADSCSV') {
      this.downloadCSV();
      this.handleActionFor('sign-out');
    } else {
      this.displaymain = true;
      this.stored_userDealers = JSON.parse(localStorage.getItem('userDealers') ?? '');
      this.stored_userDealers = _.sortBy(
        this.stored_userDealers,
        'dealer_name'
      );
      this.selectedpacode = localStorage.getItem('pacode');
      this.selectedBrand = localStorage.getItem('brand');
      this.myForm = this.fb.group({
        selectDealerControl: `${this.selectedpacode} and ${this.selectedBrand}`
      });

      this.csvData = [];
      this.utilityService.selectedAdmDealer = null;
    }
    
  }

  @HostListener('window:scroll', ['$event'])

  public setNewDealer(val: any) {
    let onlyPacode: any;
    if (val.value) {
      if (!val.value.includes('and')) {
        onlyPacode = val.value;
      } else {
        onlyPacode = val.value.substring(0, val.value.indexOf('and') - 1);
      }
      
      localStorage.setItem('pacode', onlyPacode);
      localStorage.setItem('selectedOptions', val);

      this.selectedpacode = onlyPacode;
      this.selectedIndex = val.selectedIndex;
      localStorage.setItem('brand', val.selectedOptions[0].dataset.brand);

      this.utilityService.pacodeHasChanged.next(this.selectedpacode);
      this.updateDealer();
      this.router.navigate(['success', this.router.url]);
    }
  }

  public onShowMenu(): void {
    const dashboardMenu = document.getElementById('fd-menu');
    if (this.clicked) {
      dashboardMenu!.classList.add('fd-menu-show');
    } else {
      dashboardMenu!.classList.remove('fd-menu-show');
    }
    this.clicked = !this.clicked;
  }

  public checkPermission(): void {
  // Helper to check if a specific application name is active
  const isAppActive = (name: string): boolean => {
    return this.applications.some((obj: any) => obj.name === name && obj.active === true);
  };

  // 1. Check search ads
  // True if either 'Create Search Ad' OR 'View All Search Ads' is active
  this.searchadshow = isAppActive('Create Search Ad') || isAppActive('View All Search Ads');

  // 2. Check display ads
  // True if 'Create Display Ad' is active
  this.displayadshow = isAppActive('Create Display Ad');
}


  public onShowSubMenu(): void {
    const subMenu = document.getElementById('fd-subMenu');
    if (this.menuIsOpen) {
      subMenu!.classList.remove('fd-subMenu-show');
    } else {
      subMenu!.classList.add('fd-subMenu-show');
    }
    this.menuIsOpen = !this.menuIsOpen;
  }

  public onMouseOutMenu(): void {
    const subMenu = document.getElementById('fd-subMenu');
    subMenu!.classList.remove('fd-subMenu-show');
    this.menuIsOpen = false;
  }

  public onHideSubMenu(): void {
    if (this.subClicked) {
      const subMenu = document.getElementById('fd-subMenu');
      subMenu!.classList.remove('fd-subMenu-show');
    }
  }

  public onSlideInMenu(): void {
    const slideInMenu = document.getElementById('fd-slide-in-menu');
    const shadow = document.getElementById('shadow');
    slideInMenu!.classList.add('show-menu');
    shadow!.classList.add('shadow-show');
  }

  public onToggleShadow(): void {
    const slideInMenu = document.getElementById('fd-slide-in-menu');
    const shadow = document.getElementById('shadow');

    if (this.removeShadow) {
      slideInMenu!.classList.remove('show-menu');
      shadow!.classList.remove('shadow-show');
      this.removeShadow = !this.removeShadow;
    } else {
      slideInMenu!.classList.remove('show-menu');
      shadow!.classList.remove('shadow-show');
    }
  }

  getDealer() {
    let onlyPacode: any;    
    if (this.selectedpacode.includes('and')) {
      onlyPacode = this.selectedpacode.substring(
        0,
        this.selectedpacode.indexOf('and') - 1
      );
    } else {
      onlyPacode = this.selectedpacode;
    }
    this.dealer = this.stored_userDealers;

    localStorage.setItem('zipcode', this.dealer[0].zip);
    localStorage.setItem('selectedDealer', onlyPacode);
    localStorage.setItem('dealerid', this.dealer[0].active);
    localStorage.setItem('dealername', this.dealer[0].dealer_name);
    localStorage.setItem('dealerurl', this.dealer[0].dealer_url);

  }

  getDealerNames(paCode, brand) {
    this.utilityService
      .postDealer(paCode, environment)
      .subscribe((data: JSON) => {
        this.dealer = data;
        this.dealer = _.sortBy(this.dealer, 'pacode');
        if (brand == 1) {
          this.dealerInfo.push({
            paCode: paCode,
            dealerName: this.dealer[0].fordbusinessname,
            dealerUrl: this.dealer[0].forddealerurl,
            brandCode: brand,
            zip: this.dealer[0].zip,
            active: this.dealer[0].active
          });
        } else {
          this.dealerInfo.push({
            paCode: paCode,
            dealerName: this.dealer[0].lincolnbusinessname,
            dealerUrl: this.dealer[0].lincolndealerurl,
            brandCode: brand,
            zip: this.dealer[0].zip,
            active: this.dealer[0].active
          });
        }
        this.dealerInfo = _.sortBy(this.dealerInfo, 'paCode');
      });
  }

  updateDealer() {
    let onlyPacode: any;
    if (this.selectedpacode.includes('and')) {
      onlyPacode = this.selectedpacode.substring(
        0,
        this.selectedpacode.indexOf('and') - 1
      );
    } else {
      onlyPacode = this.selectedpacode;
    }

    this.dealer = this.stored_userDealers[this.selectedIndex];
    this.selectedpacode = this.dealer.pacode;

    localStorage.setItem('zipcode', this.dealer.zip);
    localStorage.setItem('selectedDealer', onlyPacode);
    localStorage.setItem('dealerid', _.toString(this.dealer.active));
    localStorage.setItem('dealername', this.dealer.dealer_name);
    localStorage.setItem('dealerurl', this.dealer.dealer_url);
  }


  public downloadCSV(): void {
    if (this.dataType === 'search-ads') {
      this.concatOtherPacodesInCSVforSearch();
    } else {
      this.concatOtherPacodesInCSV();
    }
  }

  public concatOtherPacodesInCSVforSearch(): any {
    this.csvData = this.utilityService.searchAllModels;
    this.downloadCSVforSearch();
  }

  

  private downloadCSVforSearch() {
    if (this.csvData) {
      let count = this.csvData.filter(x => x.selected === true).length;
      if (count != 0) {


        this.globalArr = [];

        

        const createCsvFrom = data => {
          const csvRows:any[] = [];
          const headers = Object.keys(data[0]);
          csvRows.push(headers.join(','));
          for (const row of data) {
            const values = headers.map(header => {
              const escaped = ('' + row[header]).replaceAll('"', String.raw`\"`);
              return `"${escaped}"`;
            });
            csvRows.push(values.join(','));
          }
          return csvRows.join('\n');
        };

        const download = data => {
          const blob = new Blob([data], { type: 'text/csv' });
          const url = globalThis.URL.createObjectURL(blob);
          const a = document.createElement('a');
          const today = new Date();
          const dd = today.getDate();
          const mm = today.getMonth() + 1; //January is 0!
          const yyyy = today.getFullYear();
          const hh = today.getHours() + 'H';
          const min = today.getMinutes() + 'M';
          const todayDate = mm + '-' + dd + '-' + yyyy + '-' + hh + '-' + min;
          a.setAttribute('hidden', '');
          a.setAttribute('href', url);
          a.setAttribute('download', 'search-ads-' + todayDate + '.csv');
          document.body.appendChild(a);
          a.click();
          ;document.body.remove();
        };

        const csvData = createCsvFrom(this.globalArr);
        download(csvData);
      }
    }
    this.utilityService.stopLoadingSpinner();
  }

  public concatOtherPacodesInCSV(): any {
    this.utilityService.getNewDcoAllAds(environment).subscribe(
      data => {
        const valCsvData = JSON.stringify(data);
        this.saveDataforCSV(valCsvData);
        this.saveDataforCSV2(valCsvData);

        this.downloadCSVFile();
      },
      err => {
        this.showError();
      }
    );
  }

  public unique(arr, keyProps) {
    const kvArray = arr.map(entry => {
      const key = keyProps.map(k => entry[k]).join('|');
      return [key, entry];
    });
    const map = new Map(kvArray);
    return Array.from(map.values());
  }

  // saveDataforCSV2 function is specifically written for the Default Row(all changes to the default row columns go here)//
  saveDataforCSV2(myGroupedData) {
    const tmpcsvData = JSON.parse(myGroupedData);
    if (tmpcsvData && tmpcsvData.length > 0) {
      let userDealers: any = JSON.parse(localStorage.getItem('masterDealers') ?? '');
      // index csvData by pacode in masterDealers"
      let lookup = _.keyBy(userDealers, function(o) {
        return o.pacode;
      });
      let result = _.filter(tmpcsvData, function(u) {
        return lookup[u.pacode] !== undefined;
      });

      result.forEach(pitem => {
        let pacode = pitem.pacode;

        let friendlyName = userDealers
          .filter(function(el) {
            return el.pacode === pacode;
          })
          .map(function(el) {
            return el.friendly_name;
          });
        let friendlyUrl = userDealers
          .filter(function(el) {
            return el.pacode === pacode;
          })
          .map(function(el) {
            return el.friendly_url;
          });

        pitem.offer.forEach(currsvData => {
          currsvData.placement.forEach((placement, pix) => {
            if (placement.placementid.includes('-')) {
              currsvData.placementid = placement.placementid;
            } else {
              currsvData.placementid = placement.placementid.substr(
                0,
                placement.placementid.indexOf('-')
              );
            }
            currsvData.version = 0;
            currsvData.pacode = pacode;
            currsvData.template = pitem.template;
            if (currsvData.template.substr(0, 1) == 'A'){
              currsvData.template = 'A';
            }
             currsvData.offer_start_date = moment(
              currsvData.offer_start_date
            ).format('MM/DD/YYYY');
            currsvData.offer_end_date = moment(
              currsvData.offer_end_date
            ).format('MM/DD/YYYY');
            // Update Images to replace http with https and a new Azure Token. ** this is only for csv file **
            // Background Image 1
            currsvData.backgroundimage1 = currsvData.backgroundimage1.substr(
              0,
              currsvData.backgroundimage1.indexOf('?sv=')
            );
            currsvData.backgroundimage1 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';
            // Background Image 2
            currsvData.backgroundimage2 = currsvData.backgroundimage2.substr(
              0,
              currsvData.backgroundimage2.indexOf('?sv=')
            );
            currsvData.backgroundimage2 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';
            // Logo1
            currsvData.logo3 = '';
            // Logo2
            currsvData.logo2 = '';
            // Logo3
            if (currsvData.logo1.includes('?sv='))
              currsvData.logo1 = currsvData.logo1.substr(
                0,
                currsvData.logo1.indexOf('?sv=')
              );
            currsvData.logo1 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';

            // VehicleImage3
            if (currsvData.vehicleimage1.includes('?sv=')) {
              currsvData.vehicleimage3 = currsvData.vehicleimage1.substr(
                0,
                currsvData.vehicleimage1.indexOf('?sv=')
              );
            } else {
              currsvData.vehicleimage3 = currsvData.vehicleimage1;
            }
            currsvData.vehicleimage3 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';
     
            currsvData.vehicleimage2 = '';
            //offerheadline
            currsvData.offerheadline1 = '';
            currsvData.offerheadline2 = '';

            currsvData.offerheadline3 =
              'FIND YOUR NEW ' +
              pitem.model.toUpperCase() +
              ' AT ' +
              friendlyName[0].toUpperCase() +
              ' TODAY.';
            //CTA LABEL
            currsvData.ctalabel1 = 'SHOP NOW';
            currsvData.ctalabel2 = '';
            currsvData.ctalabel3 = '';
            //CTA url
            if (
              friendlyUrl !== undefined &&
              friendlyUrl !== null &&
              friendlyUrl !== ''
            ) {
              currsvData.ctaurl1 =
                friendlyUrl[0] +
                '?model=' +
                pitem.model +
                '&' +
                'year=' +
                pitem.year;
              currsvData.backgroundurl =
                friendlyUrl[0] +
                '?model=' +
                pitem.model +
                '&' +
                'year=' +
                pitem.year;
            } else {
              currsvData.ctaurl1 = currsvData.ctaurl3.replaceAll(
                'http:',
                'https:'
              );
            }

            currsvData.ctaurl2 = '';
            //Disclouser label
            currsvData.disclosurelabel1 = '';
            currsvData.disclosurelabel2 = '';
            currsvData.disclosurelabel3 = '';
            //vehicle name
            currsvData.vehiclename1 =
              'NEW ' +
              pitem.year.toUpperCase() +
              ' ' +
              pitem.make.toUpperCase() +
              ' ' +
              pitem.model.toUpperCase();
            currsvData.vehiclename2 = '';
            currsvData.vehiclename3 = '';
            //disclosure copy
            currsvData.disclosurecopy1 = '';
            currsvData.disclosurecopy2 = '';
            currsvData.disclosurecopy3 = '';
            //date
            currsvData.offer_start_date = '01/01/2001';
            currsvData.offer_end_date = '12/01/2099';
            //offer type
            currsvData.offer_type = 'default';
            //name
            currsvData.name = placement.name;

            this.csvTable2(JSON.stringify(currsvData));
          });
        });
      });
    }
    this.csvData2.forEach(element => {
      this.csvData.push(element);
    });
    this.displayCsv = true;
    this.utilityService.csvData = this.csvData;
    this.csvData2 = [];
  }

  csvTable2(csvData: any) {
    this.csvData2.push(JSON.parse(csvData));
  }

   offerTypeMapping(currOfferType: string): string {
  if (currOfferType === 'Retail Cash') {
    return 'cashfinancingoffer';
  } else if (currOfferType === 'Cash + APR/Options') {
    return 'cashaprfinancingoffer';
  } else if (currOfferType === 'Limited Offer (Retail)') {
    return 'na';
  } else if (currOfferType === 'Extract Lease - NO 800#') {
    return 'loyaltyleaseoffer';
  } else if (currOfferType === 'A/X/Z/D Lease Payment Extract') {
    return 'employeeleaseoffer';
  } else {
    return '';
  }
}
  saveDataforCSV(myGroupedData) {
    const tmpcsvData = JSON.parse(myGroupedData);
    if (tmpcsvData && tmpcsvData.length > 0) {
      let userDealers: any = JSON.parse(localStorage.getItem('masterDealers') ?? '');
      // index csvData by pacode in masterDealers"
      let lookup = _.keyBy(userDealers, function(o) {
        return o.pacode;
      });
      let result = _.filter(tmpcsvData, function(u) {
        return lookup[u.pacode] !== undefined;
      });

      result.forEach(pitem => {
        


        pitem.offer.forEach(currsvData => {
          let currOfferType = currsvData.offer_type;
          currsvData.placement.forEach((placement, pix) => {
            if (placement.placementid.includes('-')) {
              currsvData.placementid = placement.placementid;
            } else {
              currsvData.placementid = placement.placementid.substr(
                0,
                placement.placementid.indexOf('-')
              );
            }
            currsvData.name = placement.name;
            currsvData.pacode = pitem.pacode;
            currsvData.template = pitem.template;
            if (currsvData.template.substr(0, 1) == 'A')
              currsvData.template = 'A';
         
            currsvData.offer_type = this.offerTypeMapping(currOfferType);
            currsvData.offer_start_date = moment(
              currsvData.offer_start_date
            ).format('MM/DD/YYYY');
            currsvData.offer_end_date = moment(
              currsvData.offer_end_date
            ).format('MM/DD/YYYY');
            
            // Background Image 1
            currsvData.backgroundimage1 = currsvData.backgroundimage1.substr(
              0,
              currsvData.backgroundimage1.indexOf('?sv=')
            );
            currsvData.backgroundimage1 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';
            
            // Background Image 2
            currsvData.backgroundimage2 = currsvData.backgroundimage2.substr(
              0,
              currsvData.backgroundimage2.indexOf('?sv=')
            );
            currsvData.backgroundimage2 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';
          
            // Logo1
            if (currsvData.logo1.includes('?sv='))
              currsvData.logo1 = currsvData.logo1.substr(
                0,
                currsvData.logo1.indexOf('?sv=')
              );
            currsvData.logo1 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';
            // Logo2
            if (currsvData.logo2.includes('?sv='))
              currsvData.logo2 = currsvData.logo2.substr(
                0,
                currsvData.logo2.indexOf('?sv=')
              );
            currsvData.logo2 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';
            // Logo3
            if (currsvData.logo3.includes('?sv='))
              currsvData.logo3 = currsvData.logo3.substr(
                0,
                currsvData.logo3.indexOf('?sv=')
              );
            currsvData.logo3 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';
            // VehicleImage1
            if (currsvData.vehicleimage1.includes('?sv='))
              currsvData.vehicleimage1 = currsvData.vehicleimage1.substr(
                0,
                currsvData.vehicleimage1.indexOf('?sv=')
              );
            currsvData.vehicleimage1 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';
            // VehicleImage2
            if (currsvData.vehicleimage2.includes('?sv='))
              currsvData.vehicleimage2 = currsvData.vehicleimage2.substr(
                0,
                currsvData.vehicleimage2.indexOf('?sv=')
              );
            currsvData.vehicleimage2 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';
            // VehicleImage3
            if (currsvData.vehicleimage3.includes('?sv='))
              currsvData.vehicleimage3 = currsvData.vehicleimage3.substr(
                0,
                currsvData.vehicleimage3.indexOf('?sv=')
              );
            currsvData.vehicleimage3 +=
              '?sv=2018-03-28&ss=b&srt=sco&sp=rl&se=2029-02-08T02:53:56Z&st=2019-02-07T18:53:56Z&spr=https,http&sig=e9Ddp4Dumpat%2BbGr4hsj4WbEuO%2FlVQsN1%2F%2FDkjTNrtY%3D';
            this.csvTable(JSON.stringify(currsvData));
          });
        });
      });
    }
  }

  csvTable(csvData: any) {
    this.csvData.push(JSON.parse(csvData));
  }

private cleanHtmlAndSpaces(value: string | null | undefined): string {
  if (!value) {
    return '';
  }

  const doc = new DOMParser().parseFromString(value, 'text/html');
  const strippedText = doc.body.textContent || '';

  return strippedText.split(' ').filter(word => word !== '').join(' ').trim();
}



  private downloadCSVFile() {
    if (this.csvData) {

    const apiData = this.csvData.map(api => {

      const getFormattedDate = (date: string) => {
        const startDate = new Date(date);
        const year = startDate.getFullYear();
        const month = startDate.getMonth() + 1;
        const dt = startDate.getDate();
        return `${year}-${month}-${dt}`;
      };

      // ✅ Shared fields used by both if and else blocks
      const sharedFields = {
        Placement_ID: api.placementid,
        Placement_Name: this.cleanHtmlAndSpaces(api.name),
        Creative_Template: api.template,
        Version: api.version,
        PA_Code: api.pacode,

        // ✅ Using helper function - No vulnerable regex
        Offer_Headline_1: this.cleanHtmlAndSpaces(api.offerheadline1),
        Vehicle_Name_1:   this.cleanHtmlAndSpaces(api.vehiclename1),
        CTA_Label_1:      this.cleanHtmlAndSpaces(api.ctalabel1),

        Disclosure_Label_1: api.disclosurelabel1,
        Logo_1: api.logo1,
        Vehicle_Image_1: api.vehicleimage1,

        Offer_Headline_2: this.cleanHtmlAndSpaces(api.offerheadline2),
        Offer_Headline_3: this.cleanHtmlAndSpaces(api.offerheadline3),

        Vehicle_Image_3: api.vehicleimage3,
        Disclosure_Copy_1: api.disclosurecopy1,
        Background_Image_1: api.backgroundimage1,
        Background_URL: api.backgroundurl,
      };

      if (api.size == null) {
        return {
          ...sharedFields,
          Offer_Type: '',
          CTA_URL_1: api.ctaurl1,
          Start_Date: api.offer_start_date,
          End_Date: api.offer_end_date
        };
      } else {
        return {
          ...sharedFields,
          Offer_Type: api.offer_type,
          CTA_URL_1: api.ctaurl1 === '' ? api.backgroundurl : api.ctaurl1,
          Start_Date: getFormattedDate(api.offer_start_date),
          End_Date: getFormattedDate(api.offer_end_date)
        };
      }
    });

            const createCsvFrom = (data: any[]): string => {
        if (!data || data.length === 0) return '';
        
        const headers = Object.keys(data[0]);
        const headerRow = headers.join(',');
        
        const bodyRows = data.map(row => 
          headers.map(header => {
            const escaped = String(row[header] ?? '').replaceAll('"', String.raw`\"`);
            return `"${escaped}"`;
          }).join(',')
        );

        return [headerRow, ...bodyRows].join('\n');
      };


      const download = data => {
        const blob = new Blob(['\ufeff', data], { type: 'text/csv' });
        const url = globalThis.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('hidden', '');
        a.setAttribute('href', url);
        a.setAttribute('download', 'ads.csv');
        document.body.appendChild(a);
        a.click();
        document.body.remove();
      };

      const csvData = createCsvFrom(apiData);
      download(csvData);
    }
  }

  public trimcolon(url) {
    let hurl;
    hurl = url.split(':');
    hurl[0] = 'https:';
    hurl = hurl[0].concat(hurl[1]);
    return hurl;
  }

  public onNavigate() {
    globalThis.open(globalThis.location.origin + '/dcedashboard', '_blank');
  }

  public handleActionFor(actionType: string, e$?: Event): void {

    this.subClicked = true;
    switch (actionType.toLowerCase()) {
      case 'ads':
        this.utilityService.startLoadingSpinner();
        this.router.navigateByUrl('ads').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'main':
        this.utilityService.startLoadingSpinner();
        this.router.navigateByUrl('main').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'create':
        this.utilityService.startLoadingSpinner();
        localStorage.setItem('currentDcoForm', '');
        this.router.navigateByUrl('create').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'campaign':
        this.utilityService.startLoadingSpinner();
        this.router.navigateByUrl('campaign_approval').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'dealers':
        this.utilityService.startLoadingSpinner();
        this.router.navigateByUrl('dealers').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;
      case 'dcedashboard':
        this.utilityService.startLoadingSpinner();
        this.router.navigateByUrl('dcedashboard').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;
      case 'searchads':
        this.utilityService.startLoadingSpinner();
        this.router.navigateByUrl('search-ads').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'view all':
        this.utilityService.startLoadingSpinner();
        this.router.navigateByUrl('search-ads-view').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'sign-out':
        this.utilityService.startLoadingSpinner();
        localStorage.clear();
        this.msalService.logoutRedirect({ postLogoutRedirectUri: '/' });
        break;

      case 'upload':
        this.utilityService.startLoadingSpinner();
        this.router.navigateByUrl('upload-images').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'offers-dashboard':
        this.utilityService.startLoadingSpinner();
        this.router.navigateByUrl('offer-approval/dashboard').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'export':
        this.utilityService.startLoadingSpinner();
        this.utilityService.onTriggerNotification.next('buttonDisabled');
        this.router.navigateByUrl('export').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'offer-approval':
        this.utilityService.startLoadingSpinner();
        this.router.navigateByUrl('offer-approval').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      // Sub menu Actions

      case 'add offer':
        this.utilityService.startLoadingSpinner();
        localStorage.setItem('currentDcoForm', '');
        localStorage.setItem('adAction', 'add');
        this.router.navigateByUrl('create').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'clone':
        this.utilityService.startLoadingSpinner();
        localStorage.setItem('adAction', 'clone');
        this.router.navigateByUrl('create').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'edit':
        this.utilityService.startLoadingSpinner();
        localStorage.setItem('adAction', 'edit');
        this.router.navigateByUrl('create').then(() => {
          this.utilityService.stopLoadingSpinner();
        });
        break;

      case 'download':
        this.utilityService.startLoadingSpinner();
        this.downloadCSV();
        break;

      case 'submit to google ads':
        this.sendInfoToGoogle.emit(e$);
        break;
    }
  }

  public showError() {
    this.toastrService.error(`Failed to Download`, 'Failed !', {
      positionClass: 'toast-top-center',
      tapToDismiss: true,
      closeButton: true
    });
  }

  /* Download Dropdown functionalities */

  downloadAsCsv() {
    this.downloadCSV();
  }



  downloadImage() {
    this.utilityService.startLoadingSpinner();
    const zip = new JSZip();
    const clickPlacementId = localStorage.getItem('clickPlacementId');
    const clickPlacementSize = localStorage.getItem('clickPlacementSize');
    const changeNewPlaceMentId = clickPlacementId!.split('-');
    const newPlaceMentId = changeNewPlaceMentId[0];
    const fileName = 'Image_' + newPlaceMentId + '_' + clickPlacementSize;
    const leftiamge = localStorage.getItem('leftimage');
    const left = leftiamge!.replace(/^data:image\/[a-z]+;base64,/, '');

    zip.file('left.jpeg', left, { base64: true });

    zip.generateAsync({ type: 'blob' }).then(content => {
      this.utilityService.uploadZip(content, fileName, environment).subscribe(
        res => {
          if (this.successFlag === true) {
            this.showSuccess(
              'download image successful for ' + newPlaceMentId + '.'
            );
          }
        },
        err => {
          this.showError();
        }
      );
    });

    const timer = setInterval(() => {
      const zipName = 'Image_' + newPlaceMentId + '_' + clickPlacementSize;
      const url = `${
        environment.downloadAzureZip
      }${zipName}?sv=2018-03-28&ss=bf&srt=sco&sp=rwdlac&se=2028-12-13T02:07:23Z&st=2018-12-12T18:07:23Z&spr=https&sig=ViEcu%2B17PCWLsXDJlOOwaR8Npuzi7t%2FBvSscN0kxte8%3D`;
      globalThis.location.href = url;
      clearTimeout(timer);
      this.utilityService.stopLoadingSpinner();
    }, 5000);
  }


  showSuccess(msg) {
    this.toastrService.success(msg, 'Sucess !', {
      timeOut: 4000,
      positionClass: 'toast-top-center'
    });
  }

  //
  

  editBrandCode(brandcode: any) {
    let brandName: string;
    if (brandcode === 1) {
      brandName = 'FORD';
    } else {
      brandName = 'LINCOLN';
    }
    return brandName;
  }
}
